/**
 * Include your custom JavaScript here.
 *
 * We also offer some hooks so you can plug your own logic. For instance, if you want to be notified when the variant
 * changes on product page, you can attach a listener to the document:
 *
 * document.addEventListener('variant:changed', function(event) {
 *   var variant = event.detail.variant; // Gives you access to the whole variant details
 * });
 *
 * You can also add a listener whenever a product is added to the cart:
 *
 * document.addEventListener('product:added', function(event) {
 *   var variant = event.detail.variant; // Get the variant that was added
 *   var quantity = event.detail.quantity; // Get the quantity that was added
 * });
 *
 * If you are an app developer and requires the theme to re-render the mini-cart, you can trigger your own event. If
 * you are adding a product, you need to trigger the "product:added" event, and make sure that you pass the quantity
 * that was added so the theme can properly update the quantity:
 *
 * document.documentElement.dispatchEvent(new CustomEvent('product:added', {
 *   bubbles: true,
 *   detail: {
 *     quantity: 1
 *   }
 * }));
 *
 * If you just want to force refresh the mini-cart without adding a specific product, you can trigger the event
 * "cart:refresh" in a similar way (in that case, passing the quantity is not necessary):
 *
 * document.documentElement.dispatchEvent(new CustomEvent('cart:refresh', {
 *   bubbles: true
 * }));
 */

/**
 * Accessibility fix: Flickity-based carousels (slideshow, "Search Parts by Model" list) mark
 * off-screen slides with aria-hidden="true" but never remove them from the keyboard tab order.
 * This keeps tabindex in sync with aria-hidden so hidden slides can't be tabbed into.
 */
(function () {
  var SELECTOR = 'a.slideshow__slide, a.collection-item';

  function syncFocusability(el) {
    if (el.getAttribute('aria-hidden') === 'true') {
      el.setAttribute('tabindex', '-1');
    } else {
      el.removeAttribute('tabindex');
    }
  }

  function observe(el) {
    if (el.dataset.a11ySynced) return;
    el.dataset.a11ySynced = 'true';

    syncFocusability(el);

    new MutationObserver(function (mutations) {
      mutations.forEach(function (mutation) {
        if (mutation.attributeName === 'aria-hidden') {
          syncFocusability(el);
        }
      });
    }).observe(el, { attributes: true, attributeFilter: ['aria-hidden'] });
  }

  function init() {
    document.querySelectorAll(SELECTOR).forEach(observe);
  }

  document.addEventListener('DOMContentLoaded', init);

  new MutationObserver(function (mutations) {
    mutations.forEach(function (mutation) {
      mutation.addedNodes.forEach(function (node) {
        if (node.nodeType !== 1) return;
        if (node.matches && node.matches(SELECTOR)) {
          observe(node);
        }
        if (node.querySelectorAll) {
          node.querySelectorAll(SELECTOR).forEach(observe);
        }
      });
    });
  }).observe(document.documentElement, { childList: true, subtree: true });
})();
